import { FormControl, MenuItem, Select } from "@mui/material";

export default function CategoryFilter({ parents, parent, setParent }) {
    return <FormControl>
        <Select sx={{ height: 35, fontSize: 14, minWidth: 150, marginRight: 2 }}
            value={parent}
            onChange={(e) => setParent(e.target.value)}
        >
            <MenuItem value={-1} key={-1}>
                Все
            </MenuItem>
            {parents.map((item) => (
                <MenuItem value={item.id} key={item.id} >
                    {item.name}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
}
